import { render, staticRenderFns } from "./RelatorioAlteracoesADM.vue?vue&type=template&id=54c3d4d8"
import script from "./RelatorioAlteracoesADM.vue?vue&type=script&lang=js"
export * from "./RelatorioAlteracoesADM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports